import React, { useState } from 'react';
import { restaurantConfig } from '../../config/restaurantConfig';

interface BookingWidgetProps {
  language: string;
}

export const BookingWidget: React.FC<BookingWidgetProps> = ({ language }) => {
  const today = new Date();
  const formattedToday = today.toISOString().split('T')[0];
  
  const [partySize, setPartySize] = useState(2);
  const [date, setDate] = useState(formattedToday);
  const [time, setTime] = useState('19:30');
  
  // Available time slots based on restaurant hours
  const timeSlots = [
    '18:30', '19:00', '19:30', 
    '20:00', '20:30', '21:00', 
    '21:30'
  ];
  
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    // Construct TheFork URL with parameters
    // Format: https://www.thefork.pt/restaurante/restaurante-no-patio-r827550?date=2023-07-15&time=19:30&people=2
    const formattedDate = date.replace(/-/g, ''); // Remove dashes for TheFork URL format if needed
    const theForkUrl = `${restaurantConfig.social.thefork}?date=${date}&time=${time}&people=${partySize}`;
    
    // Redirect to TheFork for final booking
    window.open(theForkUrl, '_blank');
  };
  
  return (
    <div className="booking-widget bg-white rounded-lg shadow-lg p-6 max-w-md mx-auto">
      <h2 className="text-2xl font-bold mb-6 text-center text-[var(--color-pink)]">
        {language === 'en' ? 'Make a Reservation' : 'Faça uma Reserva'}
      </h2>
      
      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Party Size */}
        <div className="space-y-2">
          <label className="block text-gray-700 font-medium">
            {language === 'en' ? 'How many guests?' : 'Quantos convidados?'}
          </label>
          <div className="flex flex-wrap gap-2 mt-2">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((num) => (
              <button
                key={num}
                type="button"
                onClick={() => setPartySize(num)}
                className={`w-10 h-10 rounded-full ${
                  partySize === num 
                    ? 'bg-[var(--color-pink)] text-white' 
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                } transition-colors duration-200 flex items-center justify-center font-medium`}
              >
                {num}
              </button>
            ))}
          </div>
        </div>
        
        {/* Date Picker */}
        <div className="space-y-2">
          <label htmlFor="date" className="block text-gray-700 font-medium">
            {language === 'en' ? 'Date' : 'Data'}
          </label>
          <input
            type="date"
            id="date"
            name="date"
            value={date}
            min={formattedToday}
            onChange={(e) => setDate(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[var(--color-pink)] focus:border-transparent"
            required
          />
        </div>
        
        {/* Time Picker */}
        <div className="space-y-2">
          <label htmlFor="time" className="block text-gray-700 font-medium">
            {language === 'en' ? 'Time' : 'Hora'}
          </label>
          <div className="grid grid-cols-3 gap-2">
            {timeSlots.map((slot) => (
              <button
                key={slot}
                type="button"
                onClick={() => setTime(slot)}
                className={`px-4 py-2 rounded ${
                  time === slot
                    ? 'bg-[var(--color-pink)] text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                } transition-colors duration-200 text-center`}
              >
                {slot}
              </button>
            ))}
          </div>
        </div>
        
        {/* Submit Button */}
        <button 
          type="submit" 
          className="bg-[#C55E86] text-white w-full py-3 rounded-md font-medium hover:bg-opacity-90 transition-all duration-300 hover:shadow-md hover:text-white"
        >
          {language === 'en' ? 'Reserve Now' : 'Reservar Agora'}
        </button>
      </form>
      
      <p className="text-center text-sm mt-4 text-gray-500">
        {language === 'en' 
          ? 'Powered by TheFork reservation system' 
          : 'Alimentado pelo sistema de reservas TheFork'}
      </p>
    </div>
  );
};

export default BookingWidget; 